<template>
  <div class="editor-container">
    <div class="editor-left-container">
      <div class="el-tabs el-tabs--top el-tabs--border-card">
        <div class="el-tabs__header is-top">
          <div class="el-tabs__nav-wrap is-top">
            <div class="el-tabs__nav-scroll">
              <div
                role="tablist"
                class="el-tabs__nav is-top"
                style="transform: translateX(0px);"
              >
                <div
                  id="tab-code-editor"
                  aria-controls="pane-code-editor"
                  role="tab"
                  aria-selected="true"
                  tabindex="0"
                  class="el-tabs__item is-top is-active"
                >
                  示例编辑
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="el-tabs__content">
          <div
            role="tabpanel"
            id="pane-code-editor"
            aria-labelledby="tab-code-editor"
            class="el-tab-pane"
          >
            <section class="el-container is-vertical">
              <header
                class="el-header"
                id="editor-control-panel"
                style="height: 20px;"
              >
                <el-button
                  class="submit-button"
                  type="primary"
                  size="mini"
                  @click="submitValue"
                >
                  运行
                </el-button>
              </header>
              <main class="el-main">
                <div class="monaco-container">
                  <!--调用子组件-->
                  <div class="monaco-editor">
                    <monaco
                      ref="monaco"
                      :opts="monacoOpts"
                      @change="changeValue"
                    ></monaco>
                  </div>
                </div>
              </main>
            </section>
          </div>
        </div>
      </div>
    </div>
    <doo3d
      ref="doo3d"
      :opts="doo3dOpts"
    ></doo3d>
  </div>
</template>
<script>
import monaco from "./monaco";
import doo3d from "./doo3d";
import utils from "../common/utils";

export default {
  name: "editor",
  components: { monaco, doo3d },
  data() {
    return {
      monacoOpts: {
        value: "",
        readOnly: false,
        language: "javascript",
        theme: "vs",
      },
      doo3dOpts: {
        id: "",
      },
      default: {
        id: "1536282837278261248",
      },
    };
  },
  mounted() {
    // 接受传递操作内容
    if (this.$route.query.code != null) {
      utils.getCode(this.$route.query.code).then((res) => {
        this.monacoOpts.value = res;
      });
    }

    if (this.$route.query.id != null) {
      this.doo3dOpts.id = this.$route.query.id;
    } else {
      this.doo3dOpts.id = this.default.id;
    }

    //隐藏footer
    this.emit.emit("event_footer_show", false);
  },
  unmounted() {
    //显示footer
    this.emit.emit("event_footer_show", true);
  },
  methods: {
    changeLanguage(val) {
      this.opts.language = val;
    },
    submitValue() {
      eval(this.$refs.monaco.getVal());
    },
    changeValue(val) {
      //  console.log(val);
    },
  },
};
</script>
<style scoped>
.editor-container {
  position: absolute;
  top: 80px;
  width: 100%;
  height: 840px;
}

.editor-left-container {
  position: absolute;
  width: 43%;
  height: 100%;
  box-shadow: rgb(0 0 0 / 10%) 0px 0px 20px;
}
.monaco-container {
  position: relative;
  height: 710px;
  width: 100%;
}
.monaco-editor {
  height: 100%;
  border: 1px solid rgb(91, 93, 93);
}
.submit-button {
  position: relative;
  right: 0px;
}
.chosse-language {
  margin-bottom: 10px;
}
.el-main {
  overflow: hidden;
}
</style>